// extracted by mini-css-extract-plugin
export var pillWrapper = "_nk-0";
export var showOverflow = "_nk-1";